import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, onMounted } from 'vue'
import { ActionTypes, checkActionIcon, getActionRouteNameByAction } from '@/store/modules/actions/actionsTypes'
import useRouter from '@/composables/useRouter'
import { changeDateFormat } from '@/helpers/dateTime'
import { useI18n } from 'vue-i18n-composable'
import { ActionItem } from '@/store/modules/dashboardWidgets/dashboardWidgetsTypes'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardActionItem',
  props: {
  action: {
    type: Object as PropType<ActionItem>,
    required: true
  }
},
  setup(__props) {

const { action } = __props;



// TRANSLATIONS
const { t } = useI18n()

const text = {
  noExpedient: t('components.widgets.actions.no_expedient'),
  end: t('components.widgets.actions.end')
}

// ROUTER
const router = useRouter()

// DATA
// Referencias para comprobar si se renderiza una elipsis en el nombre
const textContainerElement = ref<Element | null>(null)
const textElement = ref<Element | null>(null)
const isTruncated = ref(false)

// COMPUTED
const icon = computed(() => {
  return checkActionIcon(action.actionType) || checkActionIcon('default')
})

// HOOKS
onMounted(() => {
  checkIfTruncated()
})

// METHODS
function goToAction() {
  const actionUrl = getActionRouteNameByAction(action.actionType as Exclude<ActionTypes, ActionTypes.ALL>) || ''
  const selectedRegisterId = action?.idAction
  const routeData = router.resolveRoute({
    name: actionUrl,
    params: { selectedRegisterId }
  })
  router.goToRoute((routeData as any).resolved)
}

function renderDate(date: string) {
  return `${text.end} ${changeDateFormat(date, 'YYYY-MM-DD', 'DD/MM/YYYY')}`
}

function checkIfTruncated() {
  if (textContainerElement.value && textElement.value) {
    const container = textContainerElement.value
    const text = textElement.value
    isTruncated.value = text.scrollWidth > container.clientWidth
  }
}

return { __sfc: true,t, text, router, textContainerElement, textElement, isTruncated, icon, goToAction, renderDate, checkIfTruncated, LexonTooltipComponent }
}

})